import type { TargetList, TargetListResponse, ScanProfile } from '../../app/modules/types/scan'

export const MOCK_TARGET_LIST: TargetList[] = [
  { id: 'tour-target-1', title: 'demo.netbaan.net', port_type: 'domain', is_verified: true, description: null },
  { id: 'tour-target-2', title: '185.213.0.0/24', port_type: 'IPRange', is_verified: true, description: null },
]

export const MOCK_TARGET_LIST_RESPONSE: TargetListResponse = {
  total_pages: 1,
  current_page: 1,
  results: MOCK_TARGET_LIST,
}

export const MOCK_WORKFLOWS: ScanProfile[] = [
  {
    id: 'tour-wf-1',
    name: 'Standard Recon',
    name_fa: 'شناسایی استاندارد',
    description: 'Full reconnaissance workflow covering DNS, ports and vulnerabilities',
    description_fa: 'جریان کار شناسایی کامل شامل DNS، پورت‌ها و آسیب‌پذیری‌ها',
    is_verify_required: false,
    is_schedule_available: true,
    is_valid: true,
    is_draft: false,
    is_public: true,
  },
  {
    id: 'tour-wf-2',
    name: 'Quick SSL Check',
    name_fa: 'بررسی سریع SSL',
    description: 'Fast SSL certificate and configuration audit',
    description_fa: 'بررسی سریع گواهی و پیکربندی SSL',
    is_verify_required: false,
    is_schedule_available: false,
    is_valid: true,
    is_draft: false,
    is_public: true,
  },
  {
    id: 'tour-wf-3',
    name: 'Vulnerability Scan',
    name_fa: 'اسکن آسیب‌پذیری',
    description: 'Deep vulnerability detection across all services',
    description_fa: 'شناسایی عمیق آسیب‌پذیری در تمام سرویس‌ها',
    is_verify_required: false,
    is_schedule_available: true,
    is_valid: true,
    is_draft: false,
    is_public: true,
  },
]

export const MOCK_WORKFLOWS_RESPONSE = {
  total_pages: 1,
  current_page: 1,
  results: MOCK_WORKFLOWS,
}

export const MOCK_WORKFLOW_FILTER_OPTIONS = {
  tags: [],
  status: [],
  entry: [],
}
